import script from "./ListSelectionDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListSelectionDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ListSelectionDialog.vue?vue&type=style&index=0&id=0bfa911e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bfa911e"]])

export default __exports__